import { IVisit, ISubscribeVisit, IStatusResponseVisit } from '../Models';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const VisitService = {
    async getAll(): Promise<IVisit[]> {
        const response = await fetch('/Umbraco/Api/VisitApi/GetAll', {
            method: 'GET',
            headers,
        });
        return await response.json();
    },

    async subscribeVisit(
        visitSubscribe: ISubscribeVisit
    ): Promise<IStatusResponseVisit> {
        const response = await fetch('/Umbraco/api/VisitorApi/Create', {
            method: 'POST',
            body: JSON.stringify(visitSubscribe),
            headers,
        });
        return await response.json();
    },
};
